// src/Components/WarningDialog/warningdialog.tsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Typography,
} from '@mui/material';

import { Close, WarningAmberRounded } from '@mui/icons-material';
import { center } from '@turf/turf';

interface WarningDialogProps {
  open: boolean;
  onClose: () => void;
  message: React.ReactNode;
  warningDialogTitle: string;
  children?: React.ReactNode; // Add children prop to pass buttons
}

const WarningDialog: React.FC<WarningDialogProps> = ({
  open,
  onClose,
  message,
  warningDialogTitle,
  children,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      PaperProps={{
        sx: {
          margin: '0',
        },
      }}
      disableScrollLock
    >
      <DialogTitle sx={{ padding: 0 }}>
        <Box display="flex" alignItems="center" justifyContent="center" padding={2}>
          <WarningAmberRounded
            sx={{ marginRight: '8px', marginBottom: '4px', fontSize: 40, color: '#1F13F3' }}
          />
          {warningDialogTitle}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography textAlign="center">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="space-between" width="100%">
          {children}
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default WarningDialog;
